import { Monogram } from "@/components/site/Monogram";

/** Branded loader — pulsing gold monogram. */
export function MonogramLoader({ label = "Loading" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center gap-4 py-20"
    >
      <Monogram
        className="h-12 w-12 text-gold animate-pulse"
        strokeWidth={5}
        title={label}
      />
      <span className="text-[10px] uppercase tracking-[0.4em] text-muted-foreground">
        {label}
      </span>
    </div>
  );
}
